import AuthenticationService from '@/services/AuthenticationService'
import PlanningService from '@/services/PlanningService'
export const navigation = {
	data () {
		return {
		}
	},
	methods: {
		logout () {
			AuthenticationService.logout()
		},
		isActive (link, id) {
			var options = []
			switch (link) {
			case 'plannings':
				options = ['plannings', 'planning-editor-edit', 'planning-editor-create']
				break
			case 'week':
				options = ['week', 'week-date']
				break
			case 'discussions':
				options = ['discussions', 'discussion']
				break
			case 'explore':
				options = ['explore']
				break
			case 'achievements':
				options = ['achievements']
				break
			case 'settings':
				options = ['settings']
				break
			case 'planning':
				options = [`/planning/${id}`]
				break
			case 'school-structure':
				options = ['school-structure']
				break
			case 'user-overview':
				options = ['user-overview']
				break
			}
			var path = id ? this.$route.path : this.$route.name
			return options.includes(path)
		},
		getOpenTasks (tasks) {
			return PlanningService.getOpenTasks(tasks)
		}
	},
	computed: {
		loggedIn () {
			return this.$store.state.authentication.loggedIn
		},
		userIsSuper () {
			return this.$store.state.authentication.user.role === 'super'
		},
		plannings () {
			return this.$store.state.plannings
		},
		username () {
			return this.$store.state.authentication.user.username
		}
	}
}
